export const BubbleMessageThinkTime = 0.5 * 1000
export const MIN_VOLUME = 20
